import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import blogService from "../../services/blogService";
import { toast } from "react-toastify";

const ManageBlog = ({
  blogs,
  loading,
  error,
  activeTab,
  setActiveTab,
  onStatusToggle,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const navigate = useNavigate();

  // Get current blogs for pagination
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate pagination numbers
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  // Reset to page 1 when tab changes
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-red-500 py-8">Error: {error}</div>;
  }

  if (blogs.length === 0) {
    return (
      <div className="col-12">
        <div className="tab-container mb-6">
          <div className="flex border-b border-gray-200">
            <button
              className={`py-2 px-4 font-medium text-sm ${
                activeTab === "approved"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => setActiveTab("approved")}
            >
              Blog đã duyệt
            </button>
            <button
              className={`py-2 px-4 font-medium text-sm ${
                activeTab === "pending"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => setActiveTab("pending")}
            >
              Blog chưa duyệt
            </button>
          </div>
        </div>

        <div className="text-center text-gray-500 py-8">
          {activeTab === "approved"
            ? "Không có blog nào đã được duyệt."
            : "Không có blog nào đang chờ duyệt."}
        </div>
      </div>
    );
  }

  const handleToggleBlog = async (blogId, currentStatus) => {
    try {
      await blogService.toggleBlogStatus(blogId);
      const newStatus = currentStatus === 1 ? 0 : 1;

      toast.success(
        newStatus === 1
          ? "Đã duyệt bài viết thành công!"
          : "Đã ẩn bài viết thành công!"
      );

      // Gọi callback để cập nhật state ở component cha
      if (onStatusToggle) {
        onStatusToggle(blogId, newStatus);
      }
    } catch (error) {
      console.error("Lỗi khi thay đổi trạng thái:", error);
      toast.error(error.message || "Có lỗi xảy ra khi thay đổi trạng thái");
    }
  };

  return (
    <div className="col-12">
      <div className="tab-container mb-6">
        <div className="flex border-b border-gray-200">
          <button
            className={`py-2 px-4 font-medium text-sm ${
              activeTab === "approved"
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("approved")}
          >
            Blog đã duyệt
          </button>
          <button
            className={`py-2 px-4 font-medium text-sm ${
              activeTab === "pending"
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("pending")}
          >
            Blog chưa duyệt
          </button>
        </div>
      </div>

      <div className="row">
        {currentBlogs.map((blog) => (
          <div className="col-xl-4 col-md-6" key={blog.id}>
            <div className="blog-item mb-2 wow fadeInUp" data-wow-delay="0.2s">
              <Link to={`/blog-detail/${blog.id}`} className="blog-img">
                <img
                  src={blog.imageUrls[0] || ""}
                  className="w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt={blog.name}
                />
              </Link>
              {blog.status === 1 ? (
                <span className="badge bg-success fs-13 fw-medium">
                  Đã duyệt
                </span>
              ) : (
                <span className="badge bg-primary fs-13 fw-medium">
                  Chưa duyệt
                </span>
              )}
              <div className="blog-info text-center">
                <div className="d-inline-flex align-items-center justify-content-center">
                  <div className="d-inline-flex align-items-center border-end pe-3  mb-2">
                    <a className="d-flex align-items-center">
                      <span className="avatar avatar-sm me-2">
                        <img
                          src={blog.userImage || ""}
                          className="rounded-circle border border-white"
                          alt={blog.authorName || "User"}
                        />
                      </span>
                      <p>{blog.authorName || "User"}</p>
                    </a>
                  </div>
                  <p className="text-white mb-2">
                    <i className="isax isax-calendar-2 me-2"></i>
                    {new Date(blog.createdDate).toLocaleDateString()}
                  </p>
                </div>
                <h5>
                  <Link to={`/blog-detail/${blog.id}`}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: blog.name || "No description available.",
                      }}
                    />
                  </Link>
                </h5>
              </div>
            </div>
            <div className="flex justify-center gap-3 mb-4">
              <button
                onClick={() => handleToggleBlog(blog.id, blog.status)}
                className={`rounded-lg py-2 px-4 text-white font-medium transition-colors duration-300 flex items-center justify-center gap-2 w-30 ${
                  blog.status === 1
                    ? "bg-gray-500 hover:bg-gray-600"
                    : "bg-green-500 hover:bg-green-600"
                }`}
              >
                {blog.status === 1 ? (
                  <>
                    <i className="fas fa-eye-slash"></i>
                    Ẩn bài
                  </>
                ) : (
                  <>
                    <i className="fas fa-check"></i>
                    Duyệt bài
                  </>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>

      <nav className="pagination-nav mb-4 mb-lg-0">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i className="fa-solid fa-chevron-left"></i>
              </span>
            </button>
          </li>
          {pageNumbers.map((number) => (
            <li
              key={number}
              className={`page-item ${currentPage === number ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => paginate(number)}>
                {number}
              </button>
            </li>
          ))}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i className="fa-solid fa-chevron-right"></i>
              </span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ManageBlog;
